import React from "react";
import "./Hero.css";

const Hero = ({ imageSrc }) => {
  return (
    <div className="hero">
      <img src={imageSrc} alt="eLogo" className="hero__image" />
      <h1 className="hero__title">Deneme</h1>
    </div>
  );
};

export default Hero;
